import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { TimelineManager } from "./NossaHistoria/TimelineManager";
import { TeamManager } from "./NossaHistoria/TeamManager";
import { ContentManager } from "./NossaHistoria/ContentManager";
import { PageVisibilityToggle } from "@/components/ui/PageVisibilityToggle";

export function NossaHistoriaManager() {
  return (
    <div className="space-y-6">
      <PageVisibilityToggle pageKey="page_nossa_historia_visible" label="Página Quem Somos" />

    <Tabs defaultValue="hero" className="w-full">
      <TabsList className="grid w-full grid-cols-6">
        <TabsTrigger value="hero">Hero</TabsTrigger>
        <TabsTrigger value="story">História</TabsTrigger>
        <TabsTrigger value="principles">Princípios</TabsTrigger>
        <TabsTrigger value="timeline">Timeline</TabsTrigger>
        <TabsTrigger value="team">Equipe</TabsTrigger>
        <TabsTrigger value="cta">CTA</TabsTrigger>
      </TabsList>

      <TabsContent value="hero" className="mt-6">
        <ContentManager section="hero" />
      </TabsContent>

      <TabsContent value="story" className="mt-6">
        <ContentManager section="story" />
      </TabsContent>

      <TabsContent value="principles" className="mt-6">
        <ContentManager section="principles" />
      </TabsContent>

      <TabsContent value="timeline" className="mt-6">
        <TimelineManager />
      </TabsContent>

      <TabsContent value="team" className="mt-6">
        <TeamManager />
      </TabsContent>

      <TabsContent value="cta" className="mt-6">
        <ContentManager section="cta" />
      </TabsContent>
    </Tabs>
    </div>
  );
}